import { Serializer } from "../serializer";

export const optional = <T>(
  serializer: Serializer<T>,
): Serializer<T | undefined> => ({
  ...serializer,
  serialize: (value) => {
    if (value === undefined) return value;
    return serializer.serialize(value);
  },
  deserialize: (raw) => {
    if (raw === undefined) return raw;
    return serializer.deserialize(raw);
  },
});
